<stages-dialog2 #dialog>
	<ng-container *ngIf="sequence$ | async as sequence">
		<stages-dialog-header></stages-dialog-header>
		<h1 [translate]="sequence!.msgKey"></h1>
		<ng-container *ngIf="isContentCreatorConfigured$ | async">
			<ng-container *ngIf="generateNamesError?.type !== 'PROMPTLOADING_ERROR'; else promptLoadingError">
				<ng-container *ngIf="selectionInput && selectionOptions.length > 0">
					<div class="form">
						<stages-input *ngIf="selectionInput" [form]="form" [input]="selectionInput" />
					</div>
				</ng-container>
				<ng-container
					[ngTemplateOutlet]="buttonBar"
					[ngTemplateOutletContext]="{
						isTop: true,
						hasResults: getGeneratedResults(form).controls.length > 0,
						sequence: sequence
					}"
				></ng-container>
				<div class="scrollable">
					<ng-container *ngIf="getGeneratedResults(form).controls.length > 0">
						<form [formGroup]="form" class="form">
							<h4 class="headline" [translate]="'ai.process.creator.widget.results'"></h4>
							<ul cdkDropList class="grouped-list" (cdkDropListDropped)="sortList($event)">
								<li
									class="group"
									*ngFor="let result of getGeneratedResults(form).controls; let i = index"
									cdkDragLockAxis="y"
									cdkDrag
								>
									<div class="dragged-item-placeholder" *cdkDragPlaceholder></div>
									<ul class="grouped-list">
										<li class="group">
											<header>
												<div class="handle draggableAreaForSort" cdkDragHandle>
													<i class="ico ico-handle"></i>
												</div>
												<input [type]="'text'" [value]="result.value" [formControl]="result" class="text name-input" />
												<div class="info maxlength">{{ getMaxInputLength(i.toString()) }}</div>
												<stages-button
													(clicked)="deleteListEntry(i)"
													[iconCSS]="'ico ico-delete'"
													[buttonCSS]="'sm cancel'"
													[showAsPlainText]="true"
													[title]="'delete'"
													[isIconOnly]="true"
												>
												</stages-button>
											</header>
											<ng-container [ngTemplateOutlet]="inputErrors" [ngTemplateOutletContext]="{ result: result }" />
										</li>
									</ul>
								</li>
							</ul>

							<stages-buttons-bottom [removeBoundaries]="true">
								<stages-button
									[buttonCSS]="'button flat'"
									(clicked)="generateElementNames(true)"
									[showAsPlainText]="true"
									[title]="'process.element.add.sequence.add.input'"
									[showLoadingSpin]="updateInProgress"
								>
								</stages-button>
							</stages-buttons-bottom>
						</form>
					</ng-container>

					<div class="info form" *ngIf="generateNamesError">
						<h4
							*ngIf="generateNamesError.type === 'FORMATTING_ERROR'"
							class="error"
							[translate]="generateNamesError.messageKey"
						></h4>
						<div *ngIf="generateNamesError.type === 'SYSTEM_ERROR'">
							<h4 class="error" [translate]="generateNamesError.messageKey"></h4>
							<p *ngIf="generateNamesError.errorResponseMessage">{{ generateNamesError.errorResponseMessage }}</p>
						</div>
					</div>
				</div>
				<ng-container
					[ngTemplateOutlet]="buttonBar"
					[ngTemplateOutletContext]="{
						isTop: false,
						hasResults: getGeneratedResults(form).controls.length > 0,
						sequence: sequence
					}"
				></ng-container>
				<footer class="footer">
					<stages-disclaimer-main [hideALittle]="true" [message]="'ai.widget.legal'"></stages-disclaimer-main>
				</footer>
			</ng-container>
		</ng-container>
	</ng-container>
</stages-dialog2>

<ng-template #inputErrors let-result="result">
	<div class="info errors input-error" *ngIf="result.errors && (result.dirty || result.touched)">
		<ng-container *ngFor="let error of Object.keys(result.errors)" [ngSwitch]="error">
			<div *ngSwitchCase="'pattern'" class="error" translate="process.element.edit.name.pattern" role="alert"></div>
			<div
				*ngSwitchCase="'max'"
				class="error"
				translate="input.maxLength"
				[translateParams]="{ length: MAX_NAME_LENGTH }"
				role="alert"
			></div>
			<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
		</ng-container>
	</div>
</ng-template>

<ng-template #buttonBar let-isTop="isTop" let-hasResults="hasResults" let-sequence="sequence">
	<ng-container *ngIf="isTop">
		<stages-buttons-bottom [isOnTop]="isTop">
			<ng-container *ngIf="!hasResults" [ngTemplateOutlet]="closeButton" />
			<stages-button
				(clicked)="generateElementNames(false)"
				[buttonCSS]="'sm save'"
				[title]="
					getGeneratedResults(form).controls.length === 0
						? 'ai.process.creator.button.noResults'
						: 'ai.process.creator.button.withResults'
				"
				[showLoadingSpin]="updateInProgress"
				[disabled]="updateInProgress"
			/>
		</stages-buttons-bottom>
	</ng-container>

	<ng-container *ngIf="!isTop && hasResults">
		<stages-buttons-bottom [isOnTop]="!isTop">
			<ng-container [ngTemplateOutlet]="closeButton" />
			<stages-button
				*ngIf="sequence"
				(clicked)="save(sequence)"
				[buttonCSS]="'sm save'"
				[title]="'save'"
				[showLoadingSpin]="saveInProgress"
				[disabled]="updateInProgress || saveInProgress"
			/>
		</stages-buttons-bottom>
	</ng-container>
</ng-template>

<ng-template #closeButton>
	<stages-button (clicked)="close()" [buttonCSS]="'sm cancel'" [title]="'cancel'" />
</ng-template>

<ng-template #promptLoadingError>
	<div class="info form" *ngIf="generateNamesError">
		<p [translate]="generateNamesError.messageKey"></p>
	</div>
	<stages-buttons-bottom>
		<ng-container [ngTemplateOutlet]="closeButton" />
	</stages-buttons-bottom>
	<footer class="footer"></footer>
</ng-template>
